// extracted by mini-css-extract-plugin
module.exports = {"text":"hero-section-with-video_text__amh_b","card-height":"hero-section-with-video_card-height__J3ncz"};